
export const Header = () => {
  return (
    <header>
    <nav className="container">
      <a href="/" className="logo">GamesLikeWordle</a>
      <ul className="nav-links">
        <li><a href="/games">Games</a></li>
        <li><a href="/features">Features</a></li>
        <li><a href="/community">Community</a></li>
      </ul>
    </nav>
  </header>
  );
};
export default Header